export default function redirectToLogin() {
  const current = window.location.origin + window.location.pathname;
  window.location.replace(`/login?redirect=${current}`);
}
